import FormTypeCreate from './create';
import FormTypeList from './list';
import FormTypeShow from './show';
import FormTypeEdit from './edit';

export default {
    create: FormTypeCreate,
    list: FormTypeList,
    show: FormTypeShow,
    edit: FormTypeEdit,
};